import { render } from "./LoadingCircle.vue?vue&type=template&id=52cde534"
const script = {}

import "./LoadingCircle.vue?vue&type=style&index=0&id=52cde534&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__